import firebase from "firebase";
require("firebase/auth");
import { AsyncStorage } from "@react-native-async-storage/async-storage";

export const AUTHENTICATE = "AUTHENTICATE";
export const LOGOUT = "LOGOUT";

let timer;

export const authenticate = (userId, token, expiryTime) => {
  return (dispatch) => {
    dispatch(setLogoutTimer(expiryTime));
    dispatch({ type: AUTHENTICATE, userId: userId, token: token });
  };
};

const processAuth = (resData) => {
  console.log(resData);
  dispatch(
    authenticate(
      resData.localId,
      resData.idToken,
      parseInt(resData.expiresIn) * 1000
    )
  );
  const expirationDate = new Date(
    new Date().getTime() + parseInt(resData.expiresIn) * 1000
  );
  saveDataToStorage(resData.idToken, resData.localId, expirationDate);
};

export const login = (email, password) => (dispatch) =>
  new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        // processAuth(resData);
        // console.log(resData);
        // dispatch(
        //   authenticate(
        //     resData.localId,
        //     resData.idToken,
        //     parseInt(resData.expiresIn) * 1000
        //   )
        // );
        // console.log("date: " + parseInt(resData.expiresIn));
        // const expirationDate = new Date(
        //   new Date().getTime() + parseInt(resData.expiresIn) * 1000
        // );
        // saveDataToStorage(resData.idToken, resData.localId, expirationDate);
        resolve();
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode === "auth/wrong-password") {
          alert("Wrong password.");
        } else if (errorCode == "auth/invalid-email") {
          alert("The Email is invalid");
        } else if (errorCode == "auth/user-not-found") {
          alert("User not found");
        } else {
          alert(errorMessage);
        }
        reject(errorMessage);
      });
  });

export const signup = (email, password) => (dispatch) =>
  new Promise((resolve, reject) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        if (errorCode == "auth/weak-password") {
          alert("The password is too weak.");
        } else if (errorCode == "auth/email-already-in-use") {
          alert("The Email is already in use.");
        } else if (errorCode == "auth/invalid-email") {
          alert("The Email is invalid");
        } else {
          alert(errorMessage);
        }
        reject(errorMessage);
      });
  });
export const logout = () => {
  clearLogoutTimer();
  AsyncStorage.removeItem("userData");
  return { type: LOGOUT };
};

const clearLogoutTimer = () => {
  if (timer) {
    clearTimeout(timer);
  }
};

const setLogoutTimer = (expirationTime) => {
  return (dispatch) => {
    timer = setTimeout(() => {
      dispatch(logout());
    }, expirationTime);
  };
};

const saveDataToStorage = (token, userId, expirationDate) => {
  AsyncStorage.setItem(
    "userData",
    JSON.stringify({
      token: token,
      userId: userId,
      expiryDate: expirationDate.toISOString(),
    })
  );
};

export const resetPassword = (email) => (dispatch) =>
  new Promise((resolve, reject) => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        alert(errorMessage);
        reject(errorMessage);
      });
  });
export const setPassword = (newPassword) => (dispatch) =>
  new Promise((resolve, reject) => {
    firebase
      .auth()
      .currentUser.updatePassword(newPassword)
      .then(() => {
        resolve();
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        alert(errorMessage);
        reject(errorMessage);
      });
  });
